import GetDataForGus from "../GetDataForGus";

document.addEventListener("DOMContentLoaded", () => {
  new GetDataForGus();
});
